import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaArrowRight, FaHome } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";
import { loginUser, setTokens, setUser } from "../../api";
import "./Login.css";
import logo from "../../Asset/Yashavi.png";

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",      
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // Input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Login
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.email.trim()) {
      toast.error("Email enter karein!");
      return;
    }

    if (!formData.password) {
      toast.error("Password enter karein!");
      return;
    }

    setLoading(true);

    try {
      // ✅ REAL API CALL
      const data = await loginUser(formData.email, formData.password);

      console.log("Login Response:", data);

      // Success
      if (data.status === "success") {
        // Save tokens
        setTokens(data.access_token, data.refresh_token);

        // Save user
        if (data.user) {
          setUser(data.user);
        }

        toast.success("Login successful! 🎉");

        // Redirect to dashboard
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 800);
      } else {
        // Error message from backend
        toast.error(data.message || "Invalid email or password!");
      }

    } catch (error) {
      console.error("Login Error:", error);
      toast.error("Server se connection nahi ho pa raha hai.");
    } finally {
      setLoading(false);
    }
  };

  // Back Home
  const handleHome = () => {
    navigate("/");
  };

  return (
    <div className="login-container">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            fontSize: "13px",
            borderRadius: "8px",
          },
        }}
      />

      <div className="login-card">
        {/* LEFT SIDE */}
        <div className="login-left">
          <img
            src={logo}
            alt="YashviTech Logo"
            className="brand-logo"
          />
        </div>

        {/* RIGHT SIDE */}
        <div className="login-right">
          <div className="login-form">
            <div className="form-header">
              <h2>Welcome Back</h2>
              <p>Sign in to manage your website</p>
            </div>

            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className="input-group">
                <FaUser className="input-icon" />
                <input
                  type="email"
                  name="email"
                  placeholder="Email address"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={loading}
                  autoComplete="email"
                />
              </div>

              {/* PASSWORD */}
              <div className="input-group">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              {/* SIGN IN BUTTON */}
              <button
                type="submit"
                className="btn-submit"
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
                {!loading && <FaArrowRight />}
              </button>

              {/* BACK HOME */}
              <button
                type="button"
                className="btn-home"
                onClick={handleHome}
                disabled={loading}
              >
                <FaHome />
                Back to Home
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;